import { createStore, combineReducers, applyMiddleware } from "redux";
import thunk from "redux-thunk";
import { composeWithDevTools } from "redux-devtools-extension";
import { contractReducer } from "./reducers/contractReducers";
import { addpaymentReducer } from "./reducers/addpaymentReducers";
import { usageReducer } from "./reducers/usageReducers";
const reducer = combineReducers({
  contractReducer: contractReducer,
  usageReducer: usageReducer,
  addpaymentReducer:addpaymentReducer
});

const middleware = [thunk];

const store = createStore(
  reducer,
  composeWithDevTools(applyMiddleware(...middleware))
);

export default store;
